import React from 'react';
import { ServiceSpec } from '../../data/servicesData';
import SpecificationsGrid from './SpecificationsGrid';
import SpecificationsGallery from './SpecificationsGallery';

interface SpecificationsLegacyProps {
  specifications: ServiceSpec[];
  gallery?: string[];
}

const SpecificationsLegacy: React.FC<SpecificationsLegacyProps> = ({
  specifications,
  gallery = []
}) => {
  // Si no hay especificaciones pero sí hay galería, mostrar solo la galería en una columna
  const hasSpecifications = specifications.length > 0;
  const hasGallery = gallery.length > 0;

  if (!hasSpecifications && hasGallery) {
    return (
      <div className="specifications-layout specifications-layout-full">
        <SpecificationsGallery images={gallery} title="Producto" />
      </div>
    );
  }

  return (
    <div className="specifications-layout">
      {hasSpecifications && <SpecificationsGrid specifications={specifications} />}

      {hasGallery && (
        <SpecificationsGallery images={gallery} title="Producto" />
      )}
    </div>
  );
};

export default SpecificationsLegacy;
